import { connect } from "react-redux";
import { Grid, MenuItem } from "@material-ui/core";
import { Formik } from "formik";

import FormTextField from "../../shared/form-text-field";
import FormSelect from "../../shared/form-select";
import Button from "../../shared/Button";
import FormDatePicker from "../../shared/form-date-picker";
import { GenerateReportFormProps } from "../../../interface/forms/GenerateReportFormProps";
import { useAppSelector } from "../../../hooks";
import { getContractorCompanies } from "../../../store/contractorStore";
import { getTransportCompanies } from "../../../store/transportStore";
import { GenerateReportFormSchema } from "../schema/generate-report-form-schema";
import FormSelectSearchField from "../../shared/form-select-search-field";

const GenerateReportForm = ({
  generateReportFormValues,
  onSubmit,
  stream,
}: GenerateReportFormProps) => {
  const contractorCompanies = useAppSelector(getContractorCompanies);
  const transportCompanies = useAppSelector(getTransportCompanies);

  return (
    <Formik
      initialValues={generateReportFormValues}
      onSubmit={(values, { setSubmitting }) => onSubmit(values, setSubmitting)}
      validationSchema={GenerateReportFormSchema}
    >
      {({ values, handleSubmit, isSubmitting, setFieldValue, resetForm }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* From/To Ticket Number */}
            <Grid item xs={12} md={6}>
              <FormTextField
                name="from"
                label="From Ticket Number"
                value={values.from}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormTextField
                name="to"
                label="To Ticket Number"
                value={values.to}
              />
            </Grid>

            {/* From/To Date */}
            <Grid item xs={12} md={6}>
              <FormDatePicker
                label="From Date"
                value={values.fromDate}
                onChange={(date: any) => setFieldValue("fromDate", date)}
                clearable
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormDatePicker
                label="To Date"
                value={values.toDate}
                onChange={(date: any) => setFieldValue("toDate", date)}
                clearable
              />
            </Grid>

            {/* Contractor Company */}
            <Grid item xs={12}>
              <FormSelectSearchField
                name="contractorCompanyId"
                placeholder="Select Contractor"
                value={
                  contractorCompanies
                    .map((c) => ({ label: c.name, value: c.id }))
                    .find((opt) => opt.value === values.contractorCompanyId) ||
                  0
                }
                options={contractorCompanies.map((c) => ({
                  label: c.name,
                  value: c.id,
                }))}
                onChange={(selectedOption: any) => {
                  setFieldValue(
                    "contractorCompanyId",
                    selectedOption ? selectedOption.value : 0
                  );
                }}
                isClearable
              />
            </Grid>

            {stream === "main" && (
              <>
                {/* Transport Company */}
                <Grid item xs={12}>
                  <FormSelectSearchField
                    name="transportCompanyId"
                    placeholder="Select Haulage Co."
                    value={
                      transportCompanies
                        .map((c) => ({ label: c.name, value: c.id }))
                        .find(
                          (opt) => opt.value === values.transportCompanyId
                        ) || 0
                    }
                    options={transportCompanies.map((c) => ({
                      label: c.name,
                      value: c.id,
                    }))}
                    onChange={(selectedOption: any) => {
                      setFieldValue(
                        "transportCompanyId",
                        selectedOption ? selectedOption.value : 0
                      );
                    }}
                    isClearable
                  />
                </Grid>

                {/* Job Site */}
                <Grid item xs={12}>
                  <FormTextField
                    name="jobSite"
                    label="Search Job Site"
                    value={values.jobSite}
                  />
                </Grid>

                {/* Project ID */}
                <Grid item xs={12}>
                  <FormTextField
                    name="projectId"
                    label="Project ID"
                    value={values.projectId}
                  />
                </Grid>
              </>
            )}

            {/* Generate and Reset Buttons */}
            <Grid item xs={6}>
              <Button
                label="Generate"
                color="primary"
                variant="contained"
                type="submit"
                disabled={isSubmitting}
              />
            </Grid>
            <Grid item xs={6}>
              <Button
                label="Reset"
                color="secondary"
                variant="outlined"
                type="button"
                disabled={isSubmitting}
                onClick={() => resetForm()}
              />
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};

export default connect()(GenerateReportForm);
